import { ACCESS_TOKEN_KEY } from '../constants'
// eslint-disable-next-line import/prefer-default-export
export const removeLocalToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}
